import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No, el sistema está diseñado desde cero. Te explicamos desde cómo agarrar la herramienta hasta cómo dar el acabado final. No necesitas conocimientos previos en construcción o remodelación.'
  }, {
    q: '¿Cuánto tiempo me llevará aprender?',
    a: 'El sistema está pensado para que puedas consumirlo a tu propio ritmo. Muchos alumnos logran entender la técnica completa y hacer sus primeras pruebas en su primera semana.'
  }, {
    q: '¿Qué materiales necesito?',
    a: 'Dentro del sistema te damos el listado exacto de materiales y herramientas básicas. No necesitas maquinaria industrial ni costosa, solo herramientas manuales accesibles.'
  }, {
    q: '¿Funciona si nunca trabajé en construcción?',
    a: 'Totalmente. De hecho, muchas veces es mejor no tener "vicios" de otros oficios. El microcemento es una técnica de detalle y prolijidad, más parecida a la pintura artística que a la albañilería pesada.'
  }, {
    q: '¿Recibo acceso inmediato?',
    a: 'Sí, apenas se confirma tu pago, recibís un correo con tus datos de acceso para entrar a la plataforma y empezar a ver el contenido en el momento.'
  }, {
    q: '¿Es un curso o un ebook?',
    a: 'Es un sistema completo en video paso a paso, acompañado de material de apoyo, plantillas y guías. Podrás ver exactamente cómo se hace cada paso en la práctica.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-12 md:py-16 px-4 bg-brand-gray border-t border-white/5" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-61">
          <h2 className="text-4xl md:text-6xl text-white" data-id="element-62">
            PREGUNTAS <span className="text-brand-yellow" data-id="element-63">FRECUENTES</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-64">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-dark border border-white/10 rounded-2xl overflow-hidden" data-id="element-65">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-brand-yellow/50" aria-expanded={openIndex === i} data-id="element-66">
                <span className="text-lg md:text-xl font-bold text-white pr-4" data-id="element-67">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-brand-yellow flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-68" />
              </button>
              <AnimatePresence data-id="element-69">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-70">
                    <div className="px-6 pb-6 text-gray-300 font-medium leading-relaxed" data-id="element-71">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}